import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-8xl font-bold text-primary-500 font-heading mb-4">404</div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mb-2 font-heading">页面未找到</h1>
        <p className="text-sm text-foreground-600 mb-6 max-w-[400px] mx-auto">
          您访问的页面不存在或已被移除，请检查网址是否正确。
        </p>
        <Link
          to="/"
          className="inline-flex px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}